import React from 'react';
import styles from './UIGameHelpRulesButton.module.scss';
import clsx from 'clsx';
import { useUIGameHelpRulesButtonContext } from './UIGameHelpRulesButtonContext.tsx';
import IconRulebook from '@static/images/icon_book.svg';
export const UIGameHelpRulesButton = ({ className })=>{
    const { showRulesPopup } = useUIGameHelpRulesButtonContext();
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
        className: clsx(styles.rulesButton, className),
        onClick: showRulesPopup,
        src: IconRulebook
    }));
};
